import React from 'react';
import { Card, Progress, List, Typography, Tag } from 'antd';
import { FileOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FileTransfer = ({ transfers = [] }) => { // Add default empty array
  const getProgress = (transfer) => {
    if (transfer.type === 'incoming' && transfer.totalSize) {
      return Math.round((transfer.receivedSize / transfer.totalSize) * 100);
    }
    return 0;
  };

  const getStatusColor = (type) => {
    return type === 'outgoing' ? 'blue' : 'green';
  };

  const getStatusText = (type) => {
    return type === 'outgoing' ? 'Sending' : 'Receiving';
  };

  const getIcon = (type) => {
    return type === 'outgoing' ? <UploadOutlined /> : <DownloadOutlined />;
  };

  return (
    <Card title="File Transfers" style={{ minHeight: '400px' }}>
      {!transfers || transfers.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px 0', color: '#999' }}>
          <FileOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
          <p>No active transfers</p>
        </div>
      ) : (
        <List
          dataSource={transfers}
          renderItem={(transfer) => (
            <List.Item>
              <List.Item.Meta
                avatar={getIcon(transfer.type)}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Text>{transfer.fileName || transfer.fileInfo?.name}</Text>
                    <Tag color={getStatusColor(transfer.type)}>
                      {getStatusText(transfer.type)}
                    </Tag>
                  </div>
                }
                description={
                  <div>
                    <Text type="secondary">
                      Size: {Math.round((transfer.totalSize || transfer.fileInfo?.size || 0) / 1024)} KB
                    </Text>
                    {transfer.type === 'incoming' && transfer.totalSize && (
                      <div style={{ marginTop: '8px' }}>
                        <Progress 
                          percent={getProgress(transfer)} 
                          size="small" 
                          status="active"
                        />
                      </div>
                    )}
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default FileTransfer;